import { makeGetRequest, makePostRequest } from 'utils/api'

export async function fetchSubscriptionPlans() {
  const response = await makeGetRequest('/api/subscription/feature/', {}, true)
  return response?.status === 200 ? response.data : []
}

export async function createCheckoutSession(plan) {
  return makePostRequest('/api/subscription/checkout-session/', { plan }, {}, true)
}

export async function upgradeSubscription(plan) {
  return makePostRequest('/api/subscription/upgrade/', { plan }, {}, true)
}

export async function downgradeSubscription(plan) {
  return makePostRequest('/api/subscription/downgrade/', { plan }, {}, true)
}

export async function cancelSubscription(reason) {
  return makePostRequest('/api/subscription/cancel/', { reason }, {}, true)
}

export async function createPortalSession() {
  return makePostRequest('/api/subscription/portal-session/', {}, {}, true)
}

export async function fetchSubscriptionSummary() {
  return makeGetRequest('/api/subscription/plan/', {}, true)
}

export async function fetchSubscriptionHistory() {
  return makeGetRequest('/api/subscription/history/', {}, true)
}

export async function fetchSubscriptionInvoices() {
  return makeGetRequest('/api/subscription/invoices/', {}, true)
}

export async function refreshCurrentUser(dispatch, setSiteUser) {
  const userResponse = await makeGetRequest('/api/user/user/', {}, true)
  if (userResponse?.status === 200 && userResponse?.data) {
    dispatch(setSiteUser(userResponse.data))
  }
  return userResponse
}
